import styled from 'styled-components'

export const Container = styled.ol`
	list-style-type: none;
	padding: 0;
	margin: 0 0 32px;
	max-width: 480px;
`
